import {
  faArrowRightFromBracket,
  faChartSimple,
  faChevronLeft
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  IonAvatar,
  IonBackButton,
  IonBadge,
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonChip,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonMenuButton,
  IonPage,
  IonProgressBar,
  IonRow,
  IonTitle,
  IonToolbar
} from "@ionic/react";
import "./teamDetail.scss";
import { useEffect, useState } from "react";
import Glide from "@glidejs/glide";
import coffeeTools from "../../CoffeeTools";
import lnbp_logo from "../../icon/icon.png";

// social netowrks icons
import facebook_icon from "./../../icon/01_facebook.svg";
import instagram_icon from "./../../icon/01_Instagram.svg";
import twitter_icon from "./../../icon/01_Twitter.svg";
import youtube_icon from "./../../icon/01_Youtube.svg";
import { dom } from "@fortawesome/fontawesome-svg-core";

const Teams: React.FC = () => {
  let base_url = process.env.REACT_APP_BASE_URL;
  let id_season = process.env.REACT_APP_ID_SEASON;
  let coffee_tools = new coffeeTools();

  const [showProgessBar, setShowProgessBar] = useState(true);

  //declared outside to make it global and used it on the page

  useEffect(() => {
    // show slider
    //start the page
    mainController.init();
    // let coffee_tools = new coffeeTools();

    // console.log(coffee_tools.test(123));
  }, []);

  var controller = (() => {
    function getPlayers(callback) {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);

      fetch(base_url + "/sports/players/team", {
        method: "Post",
        credentials: "omit",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id_team: urlParams.get("team_id")
        })
      })
        .then((response) => response.json())
        .then((response) => {
          callback(response);
        });
    }
    return {
      getPlayers: (callback) => getPlayers(callback)
    };
  })();

  let view = (() => {
    let dom_obj = {
      players_title: "js__teams_detail_players_title",
      players_list: "js__teams_detail_players_list",
      team_detail_card_logo_img: "js__team_detail_card_logo_img",
      social_network_facebook: "js__social_network_facebook",
      social_network_instagram: "js__social_network_instagram",
      social_network_youtube: "js__social_network_youtube"
    };

    // tools and helpers
    function createSectionTitles(title, dom_obj_id) {
      let container = document.getElementById(dom_obj_id);
      container.innerHTML = "";
      coffee_tools.createSectionTitle(title, container);
    }

    // players list
    function showPlayers(response) {
      console.log(response);

      // show the team card
      let team_card = document.getElementById("js__team_detail_card");

      if (response.items.length > 0) {
        let team = response.items[0].team;
        let team_logo = document.getElementById(
          dom_obj.team_detail_card_logo_img
        );
        team_logo.setAttribute("src", base_url + team.full_url_logo);

        document.getElementById("js__team_detail_card_title").innerHTML =
          team.name;

        document.getElementById(
          "js__team_detail_card_logo"
        ).style.backgroundColor = team.team_color;

        // show the social networks
        let social_network_facebook = document.getElementById(
          dom_obj.social_network_facebook
        );
        let social_network_instagram = document.getElementById(
          dom_obj.social_network_instagram
        );
        let social_network_youtube = document.getElementById(
          dom_obj.social_network_youtube
        );

        social_network_facebook.setAttribute("href", team.contact.facebook);
        social_network_instagram.setAttribute("href", team.contact.instagram);
        social_network_youtube.setAttribute("href", team.contact.youtube);

        if (team.contact.facebook == "") {
          social_network_facebook.style.display = "none";
        }
        if (team.contact.instagram == "") {
          social_network_instagram.style.display = "none";
        }
        // if(team.contact.youtube == ""){
        social_network_youtube.style.display = "none";
        // }
      }

      // shpow the playes list
      let players_list = document.getElementById(dom_obj.players_list);
      players_list.innerHTML = "";
      players_list.classList.add("players_list");
      response.items.forEach((player) => {
        let anchor = document.createElement("a");
        anchor.classList.add("players_list_item_anchor");
        anchor.setAttribute("href", "/player?player_id=" + player.id);
        let player_item = document.createElement("IonChip");
        player_item.classList.add("players_list_item");
        // player_item.setAttribute("routerLink", "/players/" + player.id_player);
        player_item.setAttribute("detail", "false");
        player_item.setAttribute("lines", "none");
        player_item.setAttribute("mode", "md");
        player_item.setAttribute("button", "true");
        player_item.setAttribute("button", "true");
        player_item.innerHTML = `
        <div class="player_detail_bar" style="background-color: ${
          player.team.team_color
        }"></div>
        <IonLabel class="player_detail_label">
          <p>${player.position}</p>
          <h2>${player.name}</h2>
        </IonLabel>
        <IonAvatar slot="start" class="player_detail_avatar" style="background-color: ${
          player.team.team_color
        }">
          <img class="player_detail_img" src="${
            base_url + player.full_url_image
          }" />
        </IonAvatar>
        `;
        anchor.appendChild(player_item);
        players_list.appendChild(anchor);
      });
    }

    return {
      dom_obj: dom_obj,
      createSectionTitles: (title, dom_obj_id) =>
        createSectionTitles(title, dom_obj_id),
      showPlayers: (response) => showPlayers(response)
    };
  })();

  var mainController = (function (page_controller, page_view) {
    var setupEventListeners = function () {};
    return {
      init: function () {
        // console.log("Menu started");
        setupEventListeners();
        // teams
        page_view.createSectionTitles(
          "Jugadores",
          page_view.dom_obj.players_title
        );

        // hide progress bar
        setShowProgessBar(false);

        // show players
        page_controller.getPlayers(page_view.showPlayers);
      }
    };
  })(controller, view);

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar
          className='home_toolbar'
          color={"secondary"}
        >
          <div hidden={!showProgessBar}>
            <IonProgressBar type='indeterminate'></IonProgressBar>
          </div>
          <IonButtons slot='start'>
            <IonMenuButton></IonMenuButton>
            <IonButton
              onClick={() => {
                window.history.back();
              }}
            >
              <FontAwesomeIcon
                size='lg'
                pull='left'
                icon={faChevronLeft}
              />
            </IonButton>
          </IonButtons>
          <div className='header_lnbp_icon'>
            <img
              src={lnbp_logo}
              alt='LNBP'
            />
          </div>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <section
          id='js__teams_detail_team'
          className='section-player-detail-half'
        >
          <div
            id='js__team_detail_card'
            className='team_detail_card'
          >
            <div style={{ position: "relative", padding: "0" }}>
              <div
                id='js__team_detail_card_logo'
                className='team_detail_card--logo'
              >
                <img
                  id='js__team_detail_card_logo_img'
                  alt='LNBP'
                />
              </div>
              <span
                id='js__team_detail_card_title'
                className='team_detail_card_title'
              ></span>
              <div
                id='js__team_social_networks'
                className='team_social_networks'
              >
                <a
                  href='http://'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <img
                    id='js__social_network_facebook'
                    src={facebook_icon}
                    alt=''
                  />
                </a>
                <a
                  href='http://'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <img
                    id='js__social_network_instagram'
                    src={instagram_icon}
                    alt=''
                  />
                </a>
                <a
                  href='http://'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <img
                    id='js__social_network_youtube'
                    src={youtube_icon}
                    alt=''
                  />
                </a>
              </div>
            </div>
          </div>
        </section>
        <section
          id='js__teams_detail_players'
          className='section-player-detail'
        >
          <span id='js__teams_detail_players_title'></span>
          <div
            id='js__teams_detail_players_list'
            className='player-list'
          ></div>
          <IonAvatar></IonAvatar>
          <IonChip></IonChip>
        </section>
      </IonContent>
    </IonPage>
  );
};

export default Teams;
